function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateVariantStatusesQuickAdd();
    this.addEventListener('change', this.onVariantChange);
    this.initializeFomoMessage();

    document.addEventListener('DOMContentLoaded', () => {
      const didChange = this.preselectLowestAvailableVariant();
      if (!didChange) {
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  initializeFomoMessage() {
    const fomoMessageScript = document.querySelector('[type="application/json"][data-variant-fomo-message]');

    if (fomoMessageScript) {
      this.variantFomoMessageFields = JSON.parse(fomoMessageScript.textContent);
    } else {
      this.variantFomoMessageFields = {};
    }
  }

  onVariantChange(event) {

    const hasQuickView = !!document.querySelector('quick-view-modal');

    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    hasQuickView ? null : this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateVariantPromoMessage();
    this.updateVariantFomoMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.toggleBISTrigger(true);

      const promoMessageWrapper = this.querySelector('[data-variant-promo-message]');
      const promoMessageTitle = this.querySelector('[data-variant-promo-title]');

      if (promoMessageWrapper) {
        promoMessageWrapper.classList.add('hidden');
        promoMessageTitle.classList.add('hidden');
      }

    } else {
      this.updateMedia();
      hasQuickView ? null : this.updateURL();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      // this.toggleBISTrigger(false);
      hasQuickView ? null : this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  preselectLowestAvailableVariant() {
    if (this.dataset.updateUrl === 'false') return false;
    if (window.location.search) return false;
    if (this.closest('quick-view-modal')) return false;
    if (this._preselectedLowestVariant) return false;

    let variants = [];
    try {
      variants = this.getVariantData();
    } catch (error) {
      return false;
    }

    const lowest = variants.reduce((acc, v) => {
      if (!v.available) return acc;
      return !acc || v.price < acc.price ? v : acc;
    }, null);

    if (!lowest) return false;

    const values = [lowest.option1, lowest.option2, lowest.option3].filter(Boolean);
    const groups = this.querySelectorAll('select, fieldset');
    let changed = false;

    values.forEach((val, idx) => {
      const group = groups[idx];
      if (!group) return;
      const safeValue = window.CSS && CSS.escape ? CSS.escape(val) : val.replace(/"/g, '\\"');
      if (group.tagName === 'SELECT') {
        if (group.value !== val) {
          group.value = val;
          changed = true;
        }
        return;
      }
      const input = group.querySelector(`input[type="radio"][value="${safeValue}"]`);
      if (input && !input.checked) {
        input.checked = true;
        changed = true;
      }
    });

    if (changed) {
      this._preselectedLowestVariant = true;
      this.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.getVariantPromoData();
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    const variantData = this.variantData;

    if (this.currentVariant) {
      const selectedOptionValue = this.currentVariant.option1;
      if (this.currentVariant.option2 == null) {
        const variantOptions = document.querySelectorAll('[data-option-type]');
        variantOptions.forEach(variantOption => {
          const optonValue = variantOption.dataset.optionId;
          // Find matching variant in variantData
          const matchingVariant = variantData.find(variant =>
            variant.option1 === optonValue
          );

          const variantAvailable = variantData.find(variant => {
            return (variant.option1 === selectedOptionValue && variant.option2 === this.currentVariant.option2 && variant.available);
          });

          // If variant is found and NOT available, add the "out-of-stock" class
          if ((matchingVariant && !matchingVariant.available) || (!variantAvailable && !matchingVariant.available)) {
            document.querySelector(`[data-option-id="${optonValue}"]`).classList.add("out-of-stock");
            document.querySelector(`[data-option-id="${optonValue}"]`).querySelector('.label-unavailable').textContent = "Out of stock";
          } else {
            document.querySelector(`[data-option-id="${optonValue}"]`).classList.remove("out-of-stock");
            document.querySelector(`[data-option-id="${optonValue}"]`).querySelector('.label-unavailable').textContent = "Available";
          }
        });
      } else {
        const sizeOptions = document.querySelectorAll('[data-option-type="Size"]');
        sizeOptions.forEach(sizeOption => {
          const sizeValue = sizeOption.dataset.optionId; // Get the value of size (e.g., "1\" or 1.5\"")

          // Find matching variant in variantData
          const matchingVariant = variantData.find(variant =>
            (variant.option1 === selectedOptionValue && variant.option2 === sizeValue)
          );

          const variantAvailable = variantData.find(variant => {
            return (variant.option1 === selectedOptionValue && variant.option2 === sizeValue && variant.available);
          });

          // If variant is found and NOT available, add the "out-of-stock" class
          if ((matchingVariant && !matchingVariant.available) || !variantAvailable) {
            sizeOption.classList.add("out-of-stock");
            sizeOption.querySelector('.label-unavailable').textContent = "Out of stock";
          } else {
            sizeOption.classList.remove("out-of-stock");
            sizeOption.querySelector('.label-unavailable').textContent = "Available";
          }
        });
      }
    } else {
      const sizeOptions = document.querySelectorAll('[data-option-type="Size"]');
      sizeOptions.forEach(sizeOption => {
        const sizeValue = sizeOption.dataset.optionId; // Get the value of size (e.g., "1\" or 1.5\"")
        const selectedOption1Value = document.querySelector('input[name="Size"]:checked')?.value;
        const variantAvailable = variantData.find(variant => {
          return (variant.option2 === sizeValue && variant.available);
        });

        if ((sizeValue === selectedOption1Value) || !variantAvailable) {
          sizeOption.classList.add("out-of-stock");
          sizeOption.querySelector('.label-unavailable').textContent = "Out of stock";
        } else {
          sizeOption.classList.remove("out-of-stock");
          sizeOption.querySelector('.label-unavailable').textContent = "Available";
        }
      });
    }

    if (window.applyKlaviyoBisNotified) {
      window.applyKlaviyoBisNotified({
        variantData: this.variantData,
        currentVariant: this.currentVariant,
        rootEl: this
      });
    }

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;

      const labelTextOutput = this.querySelector(`[data-selected-variant-text="${name}"]`);
      if (labelTextOutput) {
        labelTextOutput.textContent = value;
      }


    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // update url with utm params if they exist
    const urlParams = window.location.search;
    const urlHash = window.location.hash;
    let variantId = this.currentVariant.id;
    if (!urlParams) {
      try {
        const variants = this.getVariantData();
        const lowestSale = variants.reduce((acc, v) => {
          if (!v.available || !v.compare_at_price || v.compare_at_price <= v.price) return acc;
          return !acc || v.price < acc.price ? v : acc;
        }, null);
        if (lowestSale) variantId = lowestSale.id;
      } catch (error) {
        // keep currentVariant if variant data is unavailable
      }
    }
    let newUtmParams = '';
    if (!urlParams) {
      newUtmParams = '';
    } else if (urlParams.includes('?utm')) {
      const utmParams = urlParams.split('?');
      newUtmParams = utmParams ? '?' + utmParams.filter((param) => param.includes('utm')).join('') : '';
    } else {
      const utmParams = urlParams.split('&');
      newUtmParams = utmParams ? '&' + utmParams.filter((param) => !param.includes('variant')).join('&') : '';
    }
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${variantId}${newUtmParams ? newUtmParams : ''}${urlHash}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const textIconWithBlock = document.querySelectorAll('.text-with-icon-block');

    if (!textIconWithBlock) return;
    textIconWithBlock.forEach(el => {
      const button = el.querySelector('a');
      const originalUrl = button.href;

      if (originalUrl.includes('gifts.snakeriverfarms.com')) {
        const updatedUrl = this.updateVidParam(originalUrl, this.currentVariant.id);

        button.href = updatedUrl;
      }
    });
  }

  updateVidParam(url, newVid) {
    const urlObj = new URL(url);
    urlObj.searchParams.set('vid', newVid);
    return urlObj.toString();
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const promoAvailableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => this.variantPromoData[variant.id] && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue, promoAvailableOptionInputsValue);
    });

    if (inputWrappers.length === 1) {
      const optionInputs = [...inputWrappers[0].querySelectorAll('input[type="radio"], option')];
      const promoAvailableOptionInputsValue = this.variantData
        .filter((variant) => this.variantPromoData[variant.id])
        .map((variantOption) => variantOption[`option1`]);
      optionInputs.forEach((optionInput) => {
        const optionValue = optionInput.getAttribute('value');
        optionInput.classList.toggle('promo-available', promoAvailableOptionInputsValue.includes(optionValue));
      });
    }
  }

  updateVariantStatusesQuickAdd() {
    const gradeSaleData = this.getGradeSaleData();
    this.querySelectorAll('[data-variant-promo-title]').forEach(el => {
      el.innerHTML = '';
      el.classList.add('hidden');
    });

    if (this.querySelector('[type="application/json"][data-variants-json]')) {
      if (this.querySelector('[type="application/json"][data-variant-promos-json]')) {
        const dataJson = JSON.parse(this.querySelector('[type="application/json"][data-variants-json]').textContent);
        const dataJsonPromo = JSON.parse(this.querySelector('[type="application/json"][data-variant-promos-json]').textContent);

        const selectedOptionOneVariants = dataJson.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) {
            if (option.dataset.option != "grade") {
              return;
            }
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            optionInputs.forEach(input => {
              const value = input.value;
              const selectedOptionOneVariants = dataJson.filter(
                (variant) => value === variant.option1
              );

              const hasPromo = selectedOptionOneVariants.some(
                variant => dataJsonPromo[variant.id]
              );
              const selectedLabel = input.nextElementSibling;
              const promoEl = selectedLabel?.querySelector('[data-variant-promo-title]');
              if (!hasPromo) {
                promoEl.innerHTML = '';
                promoEl.classList.add('hidden');
              } else if (inputWrappers.length > 1) {
                const svg = `
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_68217_5787" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
                <path d="M27.9282 10.6074L10.6077 0.607422L0.607666 17.9279L17.9282 27.9279L27.9282 10.6074Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_68217_5787)">
                <path d="M25.7629 10.6842C26.058 10.8959 26.1644 11.2871 26.0129 11.6169L23.0959 17.9907C23.0663 18.0508 23.0146 18.0955 22.9526 18.1137L8.67314 21.9399C8.61528 21.9553 8.55571 21.9463 8.50361 21.9162C8.45161 21.8861 8.41455 21.8393 8.39897 21.7816L5.42648 10.6882C5.41901 10.6601 5.41699 10.631 5.42073 10.6022C5.4245 10.5733 5.43407 10.5449 5.44864 10.5196C5.46327 10.4943 5.48299 10.4719 5.50619 10.4541C5.52922 10.4365 5.55551 10.4237 5.58357 10.4162L19.863 6.58999C19.9208 6.57449 19.9805 6.58272 20.0422 6.61827L20.0499 6.62273L25.7629 10.6842ZM19.9305 11.1216C19.1334 10.6614 18.1141 10.9347 17.6538 11.7317C17.1935 12.5288 17.4666 13.5481 18.2638 14.0084C19.061 14.4686 20.0803 14.1955 20.5405 13.3983C21.0006 12.6012 20.7276 11.5818 19.9305 11.1216Z" fill="#A91F16"/>
                </g>
                </svg>
                  `;
                promoEl.innerHTML = `${svg}<span>${gradeSaleData}</span>`;
                // promoEl.innerHTML = gradeSaleData;
                promoEl.classList.remove('hidden');
              }
            });
          };
          if (index != 0) {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
            const promoAvailableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => dataJsonPromo[variant.id] && variant[`option${index}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue, promoAvailableOptionInputsValue);
          }
        });
      }
    }
  }



  setInputAvailability(elementList, availableValuesList, promoAvailableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);
      const promoAvailableElement = promoAvailableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
      element.classList.toggle('promo-available', promoAvailableElement);
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateVariantPromoMessage() {
    if (!this.variantPromoData) return;
    if (!this.currentVariant) return;
    const promoMessage = this.variantPromoData[this.currentVariant.id];
    const gradeSaleData = this.getGradeSaleData();
    const promoMessageWrapper = this.querySelector('[data-variant-promo-message]');

    if (promoMessage && promoMessageWrapper) {
      promoMessageWrapper.innerHTML = promoMessage;
      promoMessageWrapper.classList.remove('hidden');
    } else if (promoMessageWrapper) {
      promoMessageWrapper.innerHTML = '';
      promoMessageWrapper.classList.add('hidden');
    }

    this.querySelectorAll('[data-variant-promo-title]').forEach(el => {
      el.innerHTML = '';
      el.classList.add('hidden');
    });

    if (this.querySelector('[type="application/json"][data-variants-json]')) {
      if (this.querySelector('[type="application/json"][data-variant-promos-json]')) {
        const dataJson = JSON.parse(this.querySelector('[type="application/json"][data-variants-json]').textContent);
        const dataJsonPromo = JSON.parse(this.querySelector('[type="application/json"][data-variant-promos-json]').textContent);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];

        inputWrappers.forEach((option, index) => {
          if (index === 0) {
            if (option.dataset.option != "grade") {
              return;
            }
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            optionInputs.forEach(input => {
              const value = input.value;
              const selectedOptionOneVariants = dataJson.filter(
                (variant) => value === variant.option1
              );

              const hasPromo = selectedOptionOneVariants.some(
                variant => dataJsonPromo[variant.id]
              );
              const selectedLabel = input.nextElementSibling;
              const promoEl = selectedLabel?.querySelector('[data-variant-promo-title]');
              if (!hasPromo) {
                promoEl.innerHTML = '';
                promoEl.classList.add('hidden');
              } else if (inputWrappers.length > 1) {
                const svg = `
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_68217_5787" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
                <path d="M27.9282 10.6074L10.6077 0.607422L0.607666 17.9279L17.9282 27.9279L27.9282 10.6074Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_68217_5787)">
                <path d="M25.7629 10.6842C26.058 10.8959 26.1644 11.2871 26.0129 11.6169L23.0959 17.9907C23.0663 18.0508 23.0146 18.0955 22.9526 18.1137L8.67314 21.9399C8.61528 21.9553 8.55571 21.9463 8.50361 21.9162C8.45161 21.8861 8.41455 21.8393 8.39897 21.7816L5.42648 10.6882C5.41901 10.6601 5.41699 10.631 5.42073 10.6022C5.4245 10.5733 5.43407 10.5449 5.44864 10.5196C5.46327 10.4943 5.48299 10.4719 5.50619 10.4541C5.52922 10.4365 5.55551 10.4237 5.58357 10.4162L19.863 6.58999C19.9208 6.57449 19.9805 6.58272 20.0422 6.61827L20.0499 6.62273L25.7629 10.6842ZM19.9305 11.1216C19.1334 10.6614 18.1141 10.9347 17.6538 11.7317C17.1935 12.5288 17.4666 13.5481 18.2638 14.0084C19.061 14.4686 20.0803 14.1955 20.5405 13.3983C21.0006 12.6012 20.7276 11.5818 19.9305 11.1216Z" fill="#A91F16"/>
                </g>
                </svg>
                  `;
                promoEl.innerHTML = `${svg}<span>${gradeSaleData}</span>`;
                // promoEl.innerHTML = gradeSaleData;
                promoEl.classList.remove('hidden');
              }
            });
          };
        });
      }
    }
  }

  updateVariantFomoMessage() {
    if (!this.currentVariant) return;
    if (!this.variantFomoMessageFields) return;
    if(!this.variantFomoMessageFields[this.currentVariant.id]){
      return;
    }

    const currentFomoMessage =
      this.variantFomoMessageFields?.[this.currentVariant.id]?.fomo_message || '';
    const fomoMessageWrapper = document.getElementById('fomo-message-value');

    if (fomoMessageWrapper) {
      if (currentFomoMessage) {
        fomoMessageWrapper.innerHTML = currentFomoMessage;
        fomoMessageWrapper.classList.remove('hidden');
      } else {
        fomoMessageWrapper.innerHTML = '';
        fomoMessageWrapper.classList.add('hidden');
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    let oosButton = document.querySelector('.klaviyo-bis-trigger');

    if (addButton.closest('quick-view-modal')) {
      oosButton = addButton.closest('quick-view-modal').querySelector('.klaviyo-bis-trigger');
    }

    if (!addButton) return;
    if (addButton.hasAttribute('data-ctr-pdp-atc-priced')) return;

    if (disable) {
      //addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (text == 'Out of Stock') {
        addButton.setAttribute('disabled', 'disabled');
        oosButton.classList.remove('hide');
      } else {
        addButton.removeAttribute('disabled');
      }
    } else {
      addButton.removeAttribute('disabled');
      oosButton.classList.add('hide');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);


    if (!addButton) return;
    if (!addButton.hasAttribute('data-ctr-pdp-atc-priced')) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    addButton.setAttribute('disabled', 'disabled');
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  toggleBISTrigger(disable = true) {
    const section = this.closest('section');
    if (!section) return;

    const bisTriggerButton = section.querySelector('.klaviyo-bis-trigger');

    if (!bisTriggerButton) return;

    if (disable) {
      bisTriggerButton.classList.add('hide');
    } else {
      bisTriggerButton.classList.remove('hide');
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-variants-json]').textContent);
    return this.variantData;
  }

  getGradeSaleData() {
    if (this.querySelector('[type="application/json"][data-grade-sale-json]')) {
      this.gradeSaleData = this.gradeSaleData || JSON.parse(this.querySelector('[type="application/json"][data-grade-sale-json]').textContent);
    }
    return this.gradeSaleData;
  }

  getVariantPromoData() {
    if (this.querySelector('[type="application/json"][data-variants-json]')) {
      if (this.querySelector('[type="application/json"][data-variant-promos-json]')) {
        this.variantPromoData = this.variantPromoData || JSON.parse(this.querySelector('[type="application/json"][data-variant-promos-json]').textContent);
      } else {
        this.variantPromoData = {};
      }
    } else {
      this.variantPromoData = {};
    }
    return this.variantPromoData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Tiktok Video
function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });
  observer.observe(options.element);
}

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function convertBreakpoint(breakpoint) {
  let screen;
  switch (breakpoint) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 1024px)';
      break;
    case 'large-up':
      screen = '(min-width: 1025px)';
      break;
  }

  return screen
}

class DeferredMedia2 extends HTMLElement {
  constructor() {
    super();
    this.onPosterClick = this.onPosterClick.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
  }

  connectedCallback() {
    this.posterElement?.addEventListener('click', this.onPosterClick);
    this.controlElement?.addEventListener('click', this.togglePlayPause);
    this.soundElement?.addEventListener('click', this.toggleSound);

    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  disconnectedCallback() {
    this.posterElement?.removeEventListener('click', this.onPosterClick);
    this.controlElement?.removeEventListener('click', this.togglePlayPause);
    this.soundElement?.removeEventListener('click', this.toggleSound);
  }

  static get observedAttributes() {
    return ['playing', 'muted']
  }

  get autoplay() {
    return this.hasAttribute('autoplay')
  }

  get playing() {
    return this.hasAttribute('playing')
  }

  get muted() {
    return this.hasAttribute('muted')
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]')
  }

  get controlElement() {
    return this.querySelector('.media__control-button')
  }

  get soundElement() {
    return this.querySelector('.media__sound-button')
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  init() {
    if (this.autoplay) if (!this.paused) this.play();
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  togglePlayPause(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    button.classList.toggle('is-pause', this.paused);
    button.classList.toggle('is-play', !this.paused);
  }

  toggleSound(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    if (this.muted) {
      this.soundOn();
    } else {
      this.soundOff();
    }
    button.classList.toggle('is-unmuted', this.muted);
    button.classList.toggle('is-muted', !this.muted);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
        this.paused = false;
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
        this.paused = true;
      }
      this.updateControlButton();
    }
    if (name === 'muted') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:muted', { bubbles: true }));
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:unmuted', { bubbles: true }));
      }
      this.updateSoundButton();
    }
  }

  play() {
    if (!this.playing) this.player.play();
  }

  pause() {
    if (this.playing) this.player.pause();
  }

  soundOff() {
    if (!this.muted) this.player.muted();
  }

  soundOn() {
    if (this.muted) this.player.unmuted();
  }

  updateControlButton() {
    const button = this.controlElement;
    button?.classList.toggle('is-pause', this.paused);
    button?.classList.toggle('is-play', !this.paused);
  }

  updateSoundButton() {
    const button = this.soundElement;
    button?.classList.toggle('is-unmuted', this.muted);
    button?.classList.toggle('is-muted', !this.muted);
  }
}

class VideoMedia extends DeferredMedia2 {
  constructor() {
    super();
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1024px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                  this.setAttribute('muted', '');
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                  if (event.data === YT.PlayerState.ENDED) {
                    this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
                  }
                }
                if (player.isMuted()) {
                  this.setAttribute('muted', '');
                } else {
                  this.removeAttribute('muted');
                }
              }
            }
          });
        }
        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) {
            player.setMuted(true);
            this.setAttribute('muted', '');
          }
          player.on('play', () => this.setAttribute('playing', ''));
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => {
            this.removeAttribute('playing');
            this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
          });
          player.on('volumechange', () => {
            if (player.muted) {
              this.setAttribute('muted', '');
            } else {
              this.removeAttribute('muted');
            }
          });
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      const player = this.querySelector('video');
      if (player.muted) this.setAttribute('muted', '');
      // Apply necessary attributes for Mobile Safari
      player.setAttribute('playsinline', ''); // required for mobile inline playback
      player.setAttribute('preload', 'auto'); // help preload
      // Preload immediately
      player.load();
      // Force autoplay for Safari/iOS
      if (player.muted && player.autoplay) {
        const tryPlay = player.play();
        if (tryPlay && typeof tryPlay.catch === 'function') {
          tryPlay.catch(() => {
            this.setAttribute('suspended', '');
            // player.controls = true;
          });
        }
      }
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) this.removeAttribute('playing');
      });
      player.addEventListener('volumechange', () => {
        if (player.muted) {
          this.setAttribute('muted', '');
        } else {
          this.removeAttribute('muted');
        }
      });
      const handleEnd = () => {
        this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
      };
      const setupLoopDetection = () => {
        const onTimeUpdate = () => {
          const duration = player.duration;
          if (!isNaN(duration) && player.currentTime >= duration - 0.3) {
            player.removeEventListener('timeupdate', onTimeUpdate);
            handleEnd();
          }
        };
        player.addEventListener('timeupdate', onTimeUpdate);
      };

      if (player.loop) {
        if (isNaN(player.duration)) {
          player.addEventListener('loadedmetadata', setupLoopDetection, { once: true });
        } else {
          setupLoopDetection();
        }
      } else {
        player.addEventListener('ended', handleEnd);
      }
      return player;
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
          }
        });
      } else if (prop === 'muted' && !this.hasAttribute('host')) {
        target.muted = true;
      } else if (prop === 'unmuted' && !this.hasAttribute('host')) {
        target.muted = false;
      } else {
        target[prop]();
      }
    }
  }
}

customElements.define('video-media', VideoMedia);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();
    this.disable = false;
    this._onVideoEnded = null;
    this.slider = this.querySelector('.swiper');
    this.pagination = this.querySelector(`.swiper-pagination[id="Pagination-Slider-${this.dataset.sliderId}"]`) || this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prev = this.querySelector(`.swiper-navigation[id="Navigation-Slider-${this.dataset.sliderId}"] .swiper-button-prev`) || this.querySelector('.swiper-button-prev');
    this.next = this.querySelector(`.swiper-navigation[id="Navigation-Slider-${this.dataset.sliderId}"] .swiper-button-next`) || this.querySelector('.swiper-button-next');
    this.play = this.querySelector('.swiper-button-play');
    this.pause = this.querySelector('.swiper-button-pause');
    // this.count = this.querySelector('[data-swiper-count]');
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.defaultSettings = this.dataset.swiper || {};
    if (Object.keys(this.defaultSettings).length != 0) this.defaultOptions = JSON.parse(this.defaultSettings);
    this.options = Object.assign({}, this.defaultOptions);
    this.options = {
      ...this.options,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${index + 1}</span>`;
        }
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (selectedElement && selectedElement.dataset.type === 'video') this.handleVideoIn(selectedElement, element);
          this.setActiveSlideItemInit(element);
          this.checkNavigation(element);
          this.checkPagination(element);
          this.updatePagination(element);
          // Set data index attr
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        }
      }
    }
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('.swiper-slide'));
  }

  get markedItem() {
    return this._markedItem = this._markedItem || this.querySelector('.swiper-slide.swiper-slide-active [data-marked]');
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: -200
      });
    } else {
      this.init();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.scrollElement = newValue ? this.querySelector(newValue) : null;
      this.swiper?.update();
    }
  }

  init() {
    if (!this.disable) {
      this.disable = true;
      this.lastOutIndex = null;
      this.swiper = new Swiper(this.slider, this.options);
      this.setSlideHeight();
      this.lastOutIndex = this.swiper.activeIndex;

      this.swiper.on('resize', () => {
        // code here
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
        this.setSlideHeight();
      });

      this.swiper.on('update', () => {
        // code here
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
        this.setSlideHeight();
      });

      // this.swiper.on('beforeSlideChangeStart', () => {
      //   if (this.swiper.previousIndex === this.swiper.activeIndex) {
      //     this.swiper.slides.forEach((element) => {
      //       if (element.dataset.type === 'video') this.handleVideoOut(element, this.swiper);
      //     });
      //   }
      // });

      this.swiper.on('transitionStart', () => {
        let oldElement;
        if (this.swiper.previousIndex !== this.swiper.activeIndex) {
          oldElement = this.swiper.slides[this.swiper.previousIndex];
        } else {
          oldElement = this.swiper.slides[this.lastOutIndex];
        }

        if (oldElement && oldElement.dataset.type === 'video') this.handleVideoOut(oldElement, this.swiper);
        this.swiper.mousewheel.enabled = false;
        this.lastOutIndex = this.swiper.previousIndex;
      });

      this.swiper.on('transitionEnd', () => {
        let newElement = this.swiper.slides[this.swiper.activeIndex];
        if (newElement && newElement.dataset.type === 'video') this.handleVideoIn(newElement, this.swiper);
        this.swiper.mousewheel.enabled = true;
        this.lastOutIndex = this.swiper.activeIndex;
        this.handleLoop(this.swiper);
      });

      // this.swiper.on('touchStart', () => {
      //   if (this.swiper.params.autoplay.enabled && this.swiper.autoplay.running) {
      //     this.swiper.autoplay.stop();
      //     this.classList.add('theme-swiper--paused');
      //     this.play?.classList.remove('hidden');
      //     this.pause?.classList.add('hidden');
      //   }
      // });

      this.swiper.on('slideChange', () => {
        this.swiper.pagination.render();
        this.swiper.pagination.update();
        this.swiper.navigation.destroy();
        this.swiper.navigation.init();
        this.dispatchEvent(new CustomEvent('slider:change', { bubbles: true, detail: { currentPage: this.swiper.activeIndex } }));
      });

      this.swiper.on('paginationUpdate', () => {
        this.updatePagination(this.swiper);
      });

      this.swiper.on('slideChangeTransitionStart', () => {
        // code here

      });

      this.swiper.on('slideChangeTransitionEnd', () => {
        // code here
        this.handleLoop(this.swiper);
      });

      this.play?.addEventListener('click', this.playSlider.bind(this));
      this.pause?.addEventListener('click', this.pauseSlider.bind(this));

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.setActiveSlideItem(this.items.indexOf(event.target)));
      }
    } else if (this.disable) {
      if (this.swiper) {
        this.swiper.destroy();
        this.disable = false;
      }
    }
  }

  handleLoop(swiper) {
    console.log(swiper)
    if (swiper && swiper.params.loop) swiper.loopFix();
  }

  setActiveSlideItem(activeIndex) {
    this.swiper && this.swiper.slideTo(activeIndex);
  }

  setActiveSlideItemInit(swiper) {
    const indexInit = this.dataset.activeIndexInit;
    indexInit && swiper.slideTo(indexInit);
  }

  unSlider(swiper) {
    if (swiper) {
      swiper.destroy();
      this.disable = false;
    }
  }

  setSlideHeight() {
    if (!this.markedItem) return;
    this.style.setProperty('--slide-height', `${this.markedItem.offsetHeight}px`);
  }

  handleVideoOut(oldElement, swiper) {
    if (!oldElement) return;
    const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    videoElement.pause();
    if (this._onVideoEnded) {
      videoElement.removeEventListener('video:ended', this._onVideoEnded);
      this._onVideoEnded = null;
    }
  }

  handleVideoIn(newElement, swiper) {
    if (!newElement) return;
    const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    if (swiper.params.autoplay.enabled && swiper.autoplay.running) swiper.autoplay.stop();
    videoElement.play();
    const handleVideoEnd = () => {
      this._onVideoEnded = null;
      videoElement.removeEventListener('video:ended', handleVideoEnd);
      if (swiper.params.autoplay.enabled) swiper.autoplay.start();
    };
    this._onVideoEnded = handleVideoEnd;
    videoElement.addEventListener('video:ended', this._onVideoEnded);
  }

  playSlider() {
    this.play?.classList.add('hidden');
    this.pause?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = this.autoplayDelayTime;
    this.swiper.autoplay.start();
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider() {
    this.pause?.classList.add('hidden');
    this.play?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = 0;
    this.swiper.autoplay.stop();
    this.classList.add('theme-swiper--paused');
  }

  updatePagination(swiper) {
    if (!swiper) return;
    const cloneSlides = swiper.el.querySelectorAll('.swiper-slide--cloned');
    if (cloneSlides.length === 0) return;
    const bullets = swiper.pagination.bullets;
    if (bullets.length <= 1) return;
    const index = swiper.realIndex - 1;
    const halfLength = Math.floor(bullets.length / 2);
    if (index >= halfLength - 1) {
      for (let i = 0; i < halfLength; i++) {
        bullets[i].style.display = 'none';
      }
    } else {
      for (let i = halfLength; i < bullets.length; i++) {
        bullets[i].style.display = 'none';
      }
    }
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }
}

customElements.define('theme-swiper', ThemeSwiper);


document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('.desktop-tag-menus details');

  detailsElements.forEach((details) => {
    details.addEventListener('toggle', function () {
      if (details.open) {
        detailsElements.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });
      }
    });
  });
});

function defineRecipientForm() {
  if (customElements.get('recipient-form')) return true;
  if (typeof subscribe !== 'function') return false;
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        const labelEl = this.querySelector(`label[for="Recipient-checkbox-${this.dataset.sectionId}"]`);
        if (labelEl) {
          labelEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.checkboxInput.click();
            }
          });
        }
        this.checkboxInput.disabled = false;
        this.el = this.querySelector('.recipient-fields');
        if (this.el) {
          this.el.style.display = 'none';
        }
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });

        const productForm = this.closest('product-form');
        const form = this.closest('form');
        const submitBtn =
          productForm?.querySelector('[type="submit"][name="add"]') ||
          form?.querySelector('[type="submit"][name="add"]');

        this._onAddClick = (e) => {
          this.clearErrorMessage();
          const ok = this.validateRequiredFields?.() ?? true;
          if (!ok) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation?.();
          }
        };

        if (submitBtn) {
          submitBtn.addEventListener('click', this._onAddClick, true);
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        const productForm = this.closest('product-form');
        const form = this.closest('form');
        const submitBtn =
          productForm?.querySelector('[type="submit"][name="add"]') ||
          form?.querySelector('[type="submit"][name="add"]');

        if (submitBtn && this._onAddClick) {
          submitBtn.removeEventListener('click', this._onAddClick, true);
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.setRequiredState();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.setRequiredState();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      setRequiredState() {
        if (!this.nameInput) return;
        const isOn = !!this.checkboxInput?.checked;

        // required only when recipient form is enabled
        this.nameInput.toggleAttribute('required', isOn);
        this.nameInput.setAttribute('aria-required', isOn ? 'true' : 'false');
      }

      validateRequiredFields() {
        if (!this.checkboxInput?.checked) return true;

        const name = (this.nameInput?.value || '').trim();
        if (name) return true;

        // Show inline error like Shopify pattern
        const key = 'name';
        const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        const errorWrapper = this.querySelector(`#${errorMessageId}`);
        const errorTextEl = errorWrapper?.querySelector('.error-message');

        // Fallback message (replace with translation if you have one)
        const msg = window.accessibilityStrings?.recipientNameRequired || 'Recipient name is required';

        this.errorMessageWrapper.hidden = false;
        if (this.errorMessage) this.errorMessage.innerText = this.defaultErrorHeader || 'There was a problem';

        if (this.errorMessageList) {
          this.errorMessageList.appendChild(this.createErrorListItem(`#Recipient-${key}-${this.dataset.sectionId}`, msg));
        }

        if (errorTextEl) errorTextEl.innerText = `${msg}.`;
        errorWrapper?.classList.remove('hidden');

        this.nameInput.setAttribute('aria-invalid', 'true');
        this.nameInput.setAttribute('aria-describedby', errorMessageId);
        this.nameInput.focus();

        return false;
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        if (this.el) {
          this.el.style.display = '';
        }
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        if (this.el) {
          this.el.style.display = 'none';
        }
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
            inputElement.focus();
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
  return true;
}

document.addEventListener('keydown', (e) => {
  if (e.target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return;

  const btn = e.target.closest('[data-submenu-toggle]');
  if (btn && (e.key === 'Enter' || e.key === ' ')) {
    e.preventDefault();
    btn.click();
    return;
  }

  const current = e.target.closest('[role="option"]');
  if (!current) return;
  const list = current.parentElement;
  const options = Array.from(list.querySelectorAll('[role="option"]'));
  let idx = options.indexOf(current);

  if (e.key === 'Escape') {
    e.preventDefault();
    const dropdown = document.querySelector("[data-mobile-sort-wrapper]");
    if (dropdown) {
      dropdown.classList.toggle('active', false);
    }
    const trigger = document.querySelector('[data-mobile-sort-button]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
    return;
  }

  if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
    e.preventDefault();
    idx = (idx + 1) % options.length;
    options[idx].focus();
  }

  if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
    e.preventDefault();
    idx = (idx - 1 + options.length) % options.length;
    options[idx].focus();
  }

  if (e.key === ' ' || e.key === 'Enter') {
    e.preventDefault();
    current.click();
  }
});

document.addEventListener('keydown', (e) => {
  const current = e.target.closest('label[role="radio"]');
  if (!current) return;
  const group = current.closest('[role="radiogroup"]');
  if (!group) return;

  const radios = Array.from(group.querySelectorAll('label[role="radio"]'));
  if (!radios.length) return;
  const idx = radios.indexOf(current);
  if (idx === -1) return;
  let next;

  switch (e.key) {
    case 'ArrowRight':
    case 'ArrowDown':
      next = radios[(idx + 1) % radios.length];
      e.preventDefault();
      next.focus();
      return;
    case 'ArrowLeft':
    case 'ArrowUp':
      next = radios[(idx - 1 + radios.length) % radios.length];
      e.preventDefault();
      next.focus();
      return;
    case 'Enter':
    case ' ':
      e.preventDefault();
      current.click();
      return;
    default:
      return;
  }
});

// document.addEventListener('DOMContentLoaded', () => {
//   if (window.matchMedia('(max-width: 990px)').matches) {
//     const mobileMenus = document.querySelectorAll('[data-header-menu-inner]');
//     mobileMenus.forEach(menu => {
//       menu.setAttribute('inert', '');
//       menu.setAttribute('aria-hidden', 'true');
//     });
//   }
// });

// document.addEventListener('keydown', (e) => {
//   if (e.key !== 'Escape') return;
  // let closedSomething = false;

  // document.querySelectorAll('[data-dropdown-menu].active').forEach(menu => {
  //   menu.classList.remove('active');
  //   closedSomething = true;
  // });

  // const headerMenu = document.querySelector('[data-header-menu].active');
  // if (headerMenu) {
  //   headerMenu.classList.remove('active');
  //   document.body.classList.remove('header-menu-opened');
  //   if (window.matchMedia('(max-width: 990px)').matches) {
  //     const menuInner = headerMenu.querySelector('[data-header-menu-inner]');
  //     if (menuInner) menuInner.setAttribute('inert', '');
  //   }
  //   const toggler = document.querySelector('[data-header-menu-toggler]');
  //   if (toggler && typeof toggler.focus === 'function') {
  //     requestAnimationFrame(() => toggler.focus());
  //   }
  //   toggler?.classList?.remove('active');
  //   closedSomething = true;
  // }

  // if (closedSomething && !headerMenu) {
  //   const target = document.querySelector('.focus-menu');
  //   if (target && typeof target.focus === 'function') {
  //     requestAnimationFrame(() => target.focus());
  //   }
  // }
//   document
//     .querySelectorAll('[data-dropdown-menu].active')
//     .forEach((dropdownMenu) => {
//       dropdownMenu.classList.remove('active');
//     });
// });



const defineInterval = setInterval(() => {
  const success = defineRecipientForm();
  if (success) clearInterval(defineInterval);
}, 100);

document.querySelectorAll('.skip-to-content-link').forEach((el) => {
  el.addEventListener('focus', () => {
    if (document.body.classList.contains('header-menu-opened') || document.body.classList.contains('overflow-hidden')) {
      el.blur();
    }
  });
});
(() => {
  if (window.__cartA11yInstalled) return;
  window.__cartA11yInstalled = true;

  const ORIG_FETCH = window.fetch.bind(window);
  let __announceTimer, __clearTimer;
  const announce = (msg) => {
    const regionEl = document.getElementById('a11y-cart-status');
    if (!regionEl) return;

    clearTimeout(__announceTimer);
    __announceTimer = setTimeout(() => {
      clearTimeout(__clearTimer);
      regionEl.textContent = '';
      setTimeout(() => {
        regionEl.textContent = msg;
      }, 10);
      __clearTimer = setTimeout(() => {
        regionEl.textContent = '';
        regionEl.style.border = '';
        regionEl.style.borderRadius = '';
        regionEl.style.background = '';
        regionEl.style.padding = '';
      }, 10000);
    }, 350);
  };

  const buildAddedMsg = (item) => {
    const title = item?.product_title || 'Item';
    const variant = item?.variant_title ? ` - ${item.variant_title}` : '';
    return `Added “${title}${variant}” to your cart.`;
  };

  const buildQtyMsg = (item, status) => {
    if (status) {
      return item;
    }
    const title = item?.product_title || 'Item';
    const variant = item?.variant_title ? ` - ${item.variant_title}` : '';
    return `Updated “${title}${variant}”.`;
  };



  window.fetch = async (...args) => {
    const input = args[0];
    const url = (typeof input === 'string') ? input : (input && input.url) || '';
    const isAdd = url.includes('/cart/add');
    const isChange = url.includes('/cart/change');
    const isUpdate = url.includes('/cart/update');

    const resp = await ORIG_FETCH(...args);

    if (isAdd && resp.ok) {
      resp.clone().json().then(data => {
        const items = Array.isArray(data?.items) ? data.items : (data ? [data] : []);
        const last = items[items.length - 1] || {};
        announce(buildAddedMsg(last));
      }).catch(() => { });
    }

    if ((isChange || isUpdate) && resp.ok) {
      resp.clone().json().then(cart => {
        let bodyJson = {};
        try { bodyJson = args[1] && args[1].body ? JSON.parse(args[1].body) : {}; } catch (_) { }
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const updates = bodyJson?.updates || {};
        const updateKeys = Object.keys(updates);

        let changedItem = null;
        if (updateKeys.length === 1) {
          const k = updateKeys[0];
          changedItem = items.find(it => String(it.key) === String(k)) || null;
          if (changedItem) {
            announce(buildQtyMsg(changedItem, false));
            return;
          }
        }
        if (bodyJson.quantity == 0) {
          announce(buildQtyMsg('Product deleted successfully.', true));
          return;
        }
      }).catch(() => { });
    }
    return resp;
  };
})();

function detectBrowserZoom() {
  const levels = [1, 2];
  const mq = window.matchMedia("(pointer: fine)");
  let enabled = false;
  let last = null;


  const setZoom = () => {
    if (!enabled) return;

    const _body = document.body;

    window.devicePixelRatio > 2 ? _body.classList.add('body--zoomIn') : _body.classList.remove('body--zoomIn');
  }

  setZoom();

  levels.forEach(level => {
    const pixelRatio = window.matchMedia(`(resolution: ${level}dppx)`);

    pixelRatio.addEventListener('change', () => {
      setZoom();
    });
  });

  const enable = () => {
    if (enabled) return;
    enabled = true;
    last = null;
    setZoom();
  };

  const disable = () => {
    if (!enabled) return;
    enabled = false;
    document.body.classList.remove("body--zoomIn");
    last = null;
  };

  mq.matches ? enable() : disable();

  mq.addEventListener("change", (e) => {
    e.matches ? enable() : disable();
  });
}

detectBrowserZoom();

function detectBrowserZoom150() {
  const levels = [1, 1.5, 2];

  const setZoom = () => {
    const body = document.body;
    const zoomPercent = Math.round(window.devicePixelRatio * 100); // 1.5 => 150

    if (zoomPercent === 150) {
      body.classList.add('body--zoom-150');
    } else {
      body.classList.remove('body--zoom-150');
    }
  };

  setZoom();

  levels.forEach(level => {
    const mq = window.matchMedia(`(resolution: ${level}dppx)`);
    mq.addEventListener('change', setZoom);
  });
}

detectBrowserZoom150();

function updateProductCardHrefToLowestSaleVariant(event) {
  const link = event.target.closest('a.card-link');
  if (!link) return;

  const card = link.closest('.group.group-focus');
  if (!card) return;

  const lowestSaleEl = card.querySelector('[data-lowest-variant]');
  if (!lowestSaleEl) return;

  const variantId = lowestSaleEl.getAttribute('data-lowest-variant');
  if (!variantId || !/^\d+$/.test(variantId)) return;

  const href = link.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

  try {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('variant', variantId);
    const isAbsolute = /^https?:\/\//i.test(href) || href.startsWith('//');
    link.href = isAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return;
  }
}

document.addEventListener('click', updateProductCardHrefToLowestSaleVariant);

(function () {
  const notifiedVariantIds = new Set();

  function getVariantIdFromUrl(value) {
    if (!value) return '';
    const match = String(value).match(/[?&]variant=([^&]+)/);
    return match ? match[1] : '';
  }

  function getOptionOrder(rootEl) {
    const order = [];
    if (!rootEl) return order;

    rootEl.querySelectorAll('fieldset[data-option], select[name^="options["]').forEach((el) => {
      let name = '';
      if (el.tagName === 'FIELDSET') {
        name = el.getAttribute('data-option') || '';
      } else {
        const rawName = el.getAttribute('name') || '';
        const match = rawName.match(/options\[(.+)\]/);
        name = match ? match[1] : rawName;
      }
      const normalized = name.trim().toLowerCase();
      if (normalized && !order.includes(normalized)) order.push(normalized);
    });

    return order;
  }

  function getOptionIndexByName(optionName, optionOrder) {
    if (!optionName || !optionOrder.length) return 0;
    const normalized = optionName
      .replace(/^options\[/, '')
      .replace(/\]$/, '')
      .trim()
      .toLowerCase();
    const idx = optionOrder.indexOf(normalized);
    return idx >= 0 ? idx + 1 : 0;
  }

  function getOptionFromLabel(el) {
    if (!el) return { optionId: '', optionType: '' };
    let optionId = el.getAttribute('data-option-id') || '';
    let optionType = el.getAttribute('data-option-type') || '';

    if ((!optionId || !optionType) && el.control) {
      optionId = optionId || el.control.value || '';
      optionType = optionType || el.control.name || '';
    }

    if (!optionType) {
      const fieldset = el.closest('fieldset[data-option]');
      if (fieldset) optionType = fieldset.getAttribute('data-option') || '';
    }

    return { optionId, optionType };
  }

  function getSelectedOptionValues(rootEl, optionOrder, currentVariant) {
    const values = [];
    optionOrder.forEach((optionName, idx) => {
      let value = currentVariant ? currentVariant[`option${idx + 1}`] : '';

      if (!value && rootEl) {
        const fieldsets = Array.from(rootEl.querySelectorAll('fieldset[data-option]'));
        const fieldset = fieldsets.find(
          (el) => (el.getAttribute('data-option') || '').trim().toLowerCase() === optionName
        );
        if (fieldset) {
          value = fieldset.querySelector('input:checked')?.value || '';
        } else {
          const selects = Array.from(rootEl.querySelectorAll('select[name^="options["]'));
          const select = selects.find((el) => {
            const rawName = el.getAttribute('name') || '';
            const match = rawName.match(/options\[(.+)\]/);
            return (match ? match[1] : rawName).trim().toLowerCase() === optionName;
          });
          value = select ? select.value : '';
        }
      }

      values[idx] = value;
    });
    return values;
  }

  function getVariantDataFromDom(rootEl) {
    const scope = rootEl || document;
    const variantsScript = scope.querySelector('[data-variants-json]') || document.querySelector('[data-variants-json]');
    if (!variantsScript) return { variantData: null, currentVariant: null };

    try {
      const variantData = JSON.parse(variantsScript.textContent.trim());
      const variantInput = scope.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
      const variantId = variantInput ? Number(variantInput.value) : null;
      const currentVariant = variantId
        ? variantData.find((variant) => Number(variant.id) === variantId)
        : null;
      return { variantData, currentVariant };
    } catch (err) {
      return { variantData: null, currentVariant: null };
    }
  }

  function applyNotifiedClass(options) {
    const rootEl = options && options.rootEl ? options.rootEl : document;
    let variantData = options && Array.isArray(options.variantData) ? options.variantData : null;
    let currentVariant = options && options.currentVariant ? options.currentVariant : null;
    if (!variantData) {
      const fromDom = getVariantDataFromDom(rootEl);
      variantData = fromDom.variantData;
      currentVariant = currentVariant || fromDom.currentVariant;
    }
    const optionOrder = variantData ? getOptionOrder(rootEl) : [];

    rootEl.querySelectorAll('label.out-of-stock').forEach((el) => {
      const rawValue = el.getAttribute('data-variant-bis');
      const labelOption = getOptionFromLabel(el);
      const optionId = labelOption.optionId;
      const optionType = labelOption.optionType;

      let isNotified = false;

      if (variantData && optionId && optionType) {
        const optionIndex = getOptionIndexByName(optionType, optionOrder);
        const selectedValues = getSelectedOptionValues(rootEl, optionOrder, currentVariant);
        if (optionIndex) {
          const targetValues = selectedValues.slice();
          targetValues[optionIndex - 1] = optionId;

          isNotified = variantData.some((variant) => {
            if (targetValues[0] && variant.option1 !== targetValues[0]) return false;
            if (targetValues[1] && variant.option2 !== targetValues[1]) return false;
            if (targetValues[2] && variant.option3 !== targetValues[2]) return false;
            return notifiedVariantIds.has(String(variant.id));
          });
        }
      }

      if (!isNotified && rawValue) {
        const urlVariantId = getVariantIdFromUrl(rawValue);
        const resolvedId = urlVariantId || rawValue;
        if (resolvedId && notifiedVariantIds.has(String(resolvedId))) {
          isNotified = true;
        }
      }

      if (isNotified) el.classList.add('notified');
    });
  }

  function addVariantId(variantId) {
    if (!variantId) return;
    const id = String(variantId);
    notifiedVariantIds.add(id);
    applyNotifiedClass();
    const quickView = document.querySelector('quick-view-modal');
    if (quickView) {
      applyNotifiedClass({ rootEl: quickView });
    }
  }

  window.addEventListener('klaviyo:bis:submit', (e) => {
    if (!e || !e.detail) return;
    addVariantId(e.detail.variantId);
  });

  window.applyKlaviyoBisNotified = function (options) {
    applyNotifiedClass(options);
  };
})();

(function () {
  const TARGET_ID = 'recharge-bundles';
  const BODY_CLASS = 'has-recharge-bundles';
  function hideHeaderElements() {
    document.querySelectorAll('[data-search-input]').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('[data-header-menu]').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('a[href="/account"] svg').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('[data-header-menu-toggler]').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.open-form-search-mobile').forEach(el => {
      el.style.display = 'none';
    });
  }
  function checkAndApply() {
    const el = document.getElementById(TARGET_ID);
    if (el) {
      hideHeaderElements();
      return true;
    }
    return false;
  }

  if (checkAndApply()) return;
  const observer = new MutationObserver(() => {
    if (checkAndApply()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const blogSearchInput = document.getElementById('blog_search_iput');
    if (!blogSearchInput) return;

    blogSearchInput.focus({ preventScroll: true });
  });
})();

/**
 * Mobile header menu accessibility controller.
 *
 * Scope:
 * - Runs only at viewport widths up to 1023px.
 * - Targets only the custom SRF header menu selectors.
 * - Does not change the desktop menu, cart drawer, search modal,
 *   Shopify menu-drawer component, or other theme dialogs.
 *
 * Behavior:
 * - Removes closed menu content from the keyboard tab order.
 * - Restores menu focusability when the menu opens.
 * - Traps keyboard focus inside the open mobile menu.
 * - Returns focus to the menu toggle after the menu closes.
 */
(() => {
  if (window.__srfMobileMenuA11yInstalled) return;
  window.__srfMobileMenuA11yInstalled = true;

  const mobileMediaQuery = window.matchMedia('(max-width: 1023px)');

  const MENU_SELECTOR = '[data-header-menu]';
  const MENU_INNER_SELECTOR = '[data-header-menu-inner]';
  const MENU_TOGGLE_SELECTOR = '[data-header-menu-toggler]';

  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    'iframe',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let menuObserver = null;
  let bodyObserver = null;

  function getMenu() {
    return document.querySelector(MENU_SELECTOR);
  }

  function getMenuInner(menu) {
    return menu?.querySelector(MENU_INNER_SELECTOR) || null;
  }

  function getMenuToggle() {
    const toggles = Array.from(
      document.querySelectorAll(MENU_TOGGLE_SELECTOR)
    );

    return (
      toggles.find((toggle) => {
        const style = window.getComputedStyle(toggle);

        return (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          toggle.getClientRects().length > 0
        );
      }) ||
      toggles[0] ||
      null
    );
  }

  function isMobileViewport() {
    return mobileMediaQuery.matches;
  }

  function isMenuOpen(menu) {
    if (!menu) return false;

    const menuToggle = getMenuToggle();

    return (
      menu.classList.contains('active') ||
      document.body.classList.contains('header-menu-opened') ||
      menuToggle?.classList.contains('active') ||
      menu.getAttribute('aria-hidden') === 'false'
    );
  }

  function isElementVisible(element) {
    if (!element) return false;

    /*
     * Exclude elements hidden by an ancestor.
     */
    if (element.closest('[inert]')) return false;
    if (element.closest('[aria-hidden="true"]')) return false;
    if (element.closest('[hidden]')) return false;

    const computedStyle = window.getComputedStyle(element);

    return (
      computedStyle.display !== 'none' &&
      computedStyle.visibility !== 'hidden' &&
      element.getClientRects().length > 0
    );
  }

  function getMenuFocusableElements(menuInner) {
    if (!menuInner) return [];

    return Array.from(
      menuInner.querySelectorAll(FOCUSABLE_SELECTOR)
    ).filter((element) => {
      return (
        isElementVisible(element) &&
        !element.hasAttribute('disabled') &&
        element.getAttribute('aria-disabled') !== 'true' &&
        element.getAttribute('tabindex') !== '-1'
      );
    });
  }

  /**
   * Returns the currently visible menu panel.
   * When a submenu is open, focus must stay inside that submenu.
   */
  function getActiveMenuFocusScope(menu) {
    if (!menu) return null;

    const activeElement = document.activeElement;

    const submenuSelector = [
      '[data-dropdown-menu].active',
      '[data-submenu].active',
      '[data-mobile-submenu].active',
      '.mobile-submenu.active',
      '.submenu.active'
    ].join(',');

    const focusedSubmenu = activeElement?.closest(submenuSelector);

    if (focusedSubmenu && menu.contains(focusedSubmenu)) {
      return focusedSubmenu;
    }

    const activeSubmenus = Array.from(
      menu.querySelectorAll(submenuSelector)
    ).filter((submenu) => {
      const style = window.getComputedStyle(submenu);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        submenu.getClientRects().length > 0
      );
    });

    if (activeSubmenus.length) {
      return activeSubmenus[activeSubmenus.length - 1];
    }

    return getMenuInner(menu);
  }

  function applyClosedMenuState(menu, restoreFocus = true) {
    const menuInner = getMenuInner(menu);
    const menuToggle = getMenuToggle();

    if (!menuInner) return;

    const focusIsInsideMenu = menuInner.contains(document.activeElement);

    /*
     * The inert attribute removes all descendants from keyboard focus
     * and prevents pointer interaction while the menu is closed.
     */
    menuInner.setAttribute('inert', '');
    menuInner.setAttribute('aria-hidden', 'true');

    menuToggle?.setAttribute('aria-expanded', 'false');

    /*
     * Move focus out before or immediately after the menu becomes hidden.
     */
    if (focusIsInsideMenu && restoreFocus) {
      requestAnimationFrame(() => {
        if (!menuToggle) return;

        menuToggle.focus({
          preventScroll: true
        });
      });
    }
  }

  function applyOpenMenuState(menu) {
    const menuInner = getMenuInner(menu);
    const menuToggle = getMenuToggle();

    if (!menuInner) return;

    /*
     * Restore keyboard and assistive technology access when the menu opens.
     */
    menuInner.removeAttribute('inert');
    menuInner.setAttribute('aria-hidden', 'false');

    menuToggle?.setAttribute('aria-expanded', 'true');
  }

  function clearMobileAccessibilityState(menu) {
    const menuInner = getMenuInner(menu);
    const menuToggle = getMenuToggle();

    if (!menuInner) return;

    /*
     * Remove only attributes managed by this mobile-specific controller.
     * This prevents the desktop navigation from remaining inert.
     */
    menuInner.removeAttribute('inert');
    menuInner.removeAttribute('aria-hidden');

    menuToggle?.removeAttribute('aria-expanded');
  }

  function syncMenuAccessibility(options = {}) {
    const {
      restoreFocus = true
    } = options;

    const menu = getMenu();

    if (!menu) return;

    if (!isMobileViewport()) {
      clearMobileAccessibilityState(menu);
      return;
    }

    if (isMenuOpen(menu)) {
      applyOpenMenuState(menu);
    } else {
      applyClosedMenuState(menu, restoreFocus);
    }
  }

  function closeMobileMenu() {
    const menu = getMenu();
    const menuToggle = getMenuToggle();

    if (!menu) return;

    /*
    * Reset all child submenus before closing the main mobile menu.
    * Do not use the hidden attribute here because the existing submenu
    * opening logic may only toggle the active class.
    */
    menu
      .querySelectorAll('[data-dropdown-menu]')
      .forEach((submenu) => {
        submenu.classList.remove('active');
        submenu.setAttribute('aria-hidden', 'true');
        submenu.setAttribute('inert', '');
      });

    /*
    * Reset the expanded state for all controls associated with submenus.
    */
    menu
      .querySelectorAll('[aria-controls^="submenu-"]')
      .forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

    /*
    * Remove all visual open-state classes.
    */
    menu.classList.remove('active');
    menuToggle?.classList.remove('active');
    document.body.classList.remove('header-menu-opened');

    /*
    * Remove the complete closed menu from the keyboard tab order
    * and restore focus to the mobile menu toggle.
    */
    applyClosedMenuState(menu, true);
  }

  function handleMenuKeyboardNavigation(event) {
    if (!isMobileViewport()) return;

    const menu = getMenu();

    if (!menu || !isMenuOpen(menu)) return;

    if (event.key === 'Escape') {
    const activeSubmenu = Array.from(
      menu.querySelectorAll('[data-dropdown-menu].active')
    ).pop();

    /*
    * Escape trong submenu:
    * đóng submenu và trả focus về button mũi tên mobile.
    */
    if (activeSubmenu) {
      event.preventDefault();
      event.stopPropagation();

      const submenuId = activeSubmenu.id;

      const submenuTrigger = submenuId
        ? menu.querySelector(
            `[data-submenu-toggle][aria-controls="${CSS.escape(submenuId)}"]`
          )
        : null;

      activeSubmenu.classList.remove('active');
      activeSubmenu.setAttribute('aria-hidden', 'true');
      activeSubmenu.setAttribute('inert', '');

      if (submenuTrigger) {
        submenuTrigger.setAttribute('aria-expanded', 'false');

        const openLabel = submenuTrigger.dataset.openLabel;
        if (openLabel) {
          submenuTrigger.setAttribute('aria-label', openLabel);
        }

        requestAnimationFrame(() => {
          submenuTrigger.focus({
            preventScroll: true
          });
        });
      }

      return;
    }

    /*
    * Escape trong menu cấp ngoài:
    * đóng toàn bộ menu và trả focus về hamburger.
    */
    event.preventDefault();
    event.stopPropagation();

    closeMobileMenu();
    return;
  }

    if (event.key !== 'Tab') return;

    const focusScope = getActiveMenuFocusScope(menu);
    const focusableElements = getMenuFocusableElements(focusScope);

    /*
     * Prevent focus from escaping if the open menu temporarily contains
     * no valid focusable elements.
     */
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    const activeElement = document.activeElement;
    const focusIsInsideMenu = focusScope.contains(activeElement);

    /*
     * If focus somehow starts outside the open menu, move it back inside.
     */
    if (!focusIsInsideMenu) {
      event.preventDefault();

      if (event.shiftKey) {
        lastFocusableElement.focus();
      } else {
        firstFocusableElement.focus();
      }

      return;
    }

    /*
     * Shift + Tab on the first item loops to the last item.
     */
    if (
      event.shiftKey &&
      activeElement === firstFocusableElement
    ) {
      event.preventDefault();
      lastFocusableElement.focus();
      return;
    }

    /*
     * Tab on the last item loops to the first item.
     */
    if (
      !event.shiftKey &&
      activeElement === lastFocusableElement
    ) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }

  function handleClosedMenuFocus(event) {
    if (!isMobileViewport()) return;

    const menu = getMenu();
    const menuInner = getMenuInner(menu);

    if (
      !menu ||
      !menuInner ||
      isMenuOpen(menu) ||
      !menuInner.contains(event.target)
    ) {
      return;
    }

    /*
     * Safety fallback:
     * If another script programmatically focuses a hidden menu item,
     * immediately return focus to the menu toggle.
     */
    requestAnimationFrame(() => {
      getMenuToggle()?.focus();
    });
  }

  function handleMenuClick(event) {
    const clickedMenuControl = event.target.closest(
      `${MENU_TOGGLE_SELECTOR}, ${MENU_SELECTOR}`
    );

    if (!clickedMenuControl) return;

    /*
     * Allow the existing theme click handler to update its active classes
     * first, then synchronize accessibility attributes.
     */
    requestAnimationFrame(() => {
      syncMenuAccessibility();
    });
  }

  function initializeMobileMenuAccessibility() {
    const menu = getMenu();

    if (!menu) return;

    /*
     * Observe the menu class because the existing theme script controls
     * open and closed states by adding or removing the active class.
     */
    menuObserver = new MutationObserver(() => {
      syncMenuAccessibility();
    });

    menuObserver.observe(menu, {
      attributes: true,
      attributeFilter: ['class']
    });

    /*
     * Observe the body class because header-menu-opened is also used as
     * an open-state signal by the existing theme implementation.
     */
    bodyObserver = new MutationObserver(() => {
      syncMenuAccessibility();
    });

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    /*
     * The menu starts closed on mobile.
     * Do not move focus during initial page setup.
     */
    syncMenuAccessibility({
      restoreFocus: false
    });
  }

  document.addEventListener(
    'keydown',
    handleMenuKeyboardNavigation
  );

  document.addEventListener(
    'focusin',
    handleClosedMenuFocus,
    true
  );

  document.addEventListener(
    'click',
    handleMenuClick,
    true
  );

  mobileMediaQuery.addEventListener('change', () => {
    syncMenuAccessibility({
      restoreFocus: false
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMobileMenuAccessibility,
      {
        once: true
      }
    );
  } else {
    initializeMobileMenuAccessibility();
  }
})();